import styles from './backdrop.module.scss';
import MaterialBackdrop from '@mui/material/Backdrop';

/* eslint-disable-next-line */
export interface BackdropProps {
  open: boolean,
  children?: any,
  // classes?: object,
  // component?: any,
  // components?: any,
  // componentsProps?: object,
  invisible?: boolean,
  sx?: any,
  // transitionDuration?:
  // number |
  // {
  //   appear?: number,
  //   enter?: number,
  //   exit?: number
  // },
  onClick?: (...args: any[]) => void,
}

export function Backdrop(props: BackdropProps) {
  return (
    <MaterialBackdrop
      open={props.open}
      sx={props.sx}
      onClick={props.onClick}
      invisible={props.invisible}>
      {props.children}
    </MaterialBackdrop>
  );
}

export default Backdrop;
